define([
    "models/menu_data",
    "models/system/systemFunctions",
    "../help"
], function (menu, sysFunc, helpfile) {

    function activateMenuScroll() {
        var tree = $$("app:menu");
        if (!tree || !tree._dataobj) {
            return;
        }
        var node = tree._dataobj.parentNode;
        if (!node) {
            return;
        }
        // Overlay/custom scroll only attaches after mouseover.
        // Opening the panel (or a branch) under the cursor never fires that event.
        if (typeof MouseEvent === "function") {
            node.dispatchEvent(new MouseEvent("mouseover", {
                bubbles: true,
                cancelable: true,
                view: window
            }));
        }
        if (webix.CustomScroll && webix.CustomScroll.resize) {
            webix.CustomScroll.resize();
        }
        if (tree.focus) {
            tree.focus();
        }
    }

    return {
        $uiMobile: function (app, user) {
            return {
                width: 340,
                position: "left",
                view: "sidemenu",
                id: "menu",
                animate: false,
                on: {
                    onShow: function () {
                        webix.delay(activateMenuScroll, this, [], 50);
                    }
                },
                body: {
                    view: "tree",
                    id: "app:menu",
                    type: "menuTree2",
                    collapsed: true,
                    css: "mob_menu",
                    activeTitle: true,
                    select: true,
                    scroll: true,
                    tooltip: {
                        template: function (obj) {
                            return obj.$count ? "" : obj.details;
                        }
                    },
                    on: {
                        onBeforeSelect: function (id) {
                            if (this.getItem(id).$count) {
                                return false;
                            }
                        },
                        onAfterSelect: function (id) {
                            if (id === "help") {
                                webix.ui(helpfile.$ui).show();
                            } else {
                                app.show("./" + id);
                                var item = this.getItem(id);
                                webix.$$("title").parse({title: item.value, details: item.details});
                            }
                            $$("menu").hide();
                            if ($$("mainLayout")) {
                                $$("mainLayout").showProgress({});
                            }
                        },
                        onItemClick: function (id) {
                            if (this.isSelected(id)) {
                                $$("menu").hide();
                                $$("mainLayout").hideProgress();
                            }
                        },
                        onAfterOpen: activateMenuScroll,
                        onAfterClose: activateMenuScroll
                    },
                    data: menu.getDataArray(user)
                }
            };
        }
    };
});
